import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import { addNotification } from '../../actions/ErrorActions';


import {
  BulmaHero
} from '../../components/HelperComponents/HelperComponents';

import {
  PrimaryButton,
  InputBlack,
  OrderSummaryH1,
  OrderSummaryH2,
  OrderSummaryH3,
  VerticalForm
} from '../../components/HelperComponents/StyledComponents';

import BackgroundImage from '../../images/background.png';

import { SongOrder } from '../../components';

import { requestOrdersFromLocalStorage, requestOrder } from '../../actions/OrderActions';

// Our inner form component which receives our form's state and updater methods as props
const InnerForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
}) => (
  <form onSubmit={handleSubmit}>
    <VerticalForm>
      <div className="field">
        <div className="control" >
          <label className="label has-text-white">Country</label>
          <InputBlack
            className="input is-transparent is-rounded"
            type="text"
            name="order_country"
            placeholder="Example: Worldwide, USA, Spain"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.order_country}
          />
          {touched.order_country && errors.order_country && <p className="help is-danger">{errors.order_country}</p>}
        </div>
      </div>
      <div className="field">
        <div className="control" >
          <label className="label has-text-white">Media</label>
          <InputBlack
            className="input is-transparent is-rounded"
            type="text"
            name="order_media"
            placeholder="Example: Broadcast, Paid Online"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.order_media}
          />
          {touched.order_media && errors.order_media && <p className="help is-danger">{errors.order_media}</p>}
        </div>
      </div>
        
      <div className="field">
        <label className="label has-text-white">License Term</label>
        <InputBlack
          className="input is-rounded"
          type="text"
          name="order_license"
          placeholder="Example: 2 Years"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.order_license}
        />
        {touched.order_license && errors.order_license && <p className="help is-danger">{errors.order_license}</p>}
      </div>

      <div className="field">
        <label className="label has-text-white">Would you like the track customised?</label>
        <section className="control">
          <label className="radio has-text-white">
            <input type="radio" name="order_customized" value="1" onChange={handleChange} onBlur={handleBlur} />
            <span style={{ marginLeft: '5px' }}>Yes</span>
          </label>
          <label className="radio has-text-white">
            <input type="radio" name="order_customized" value="0" onChange={handleChange} onBlur={handleBlur} />
            <span style={{ marginLeft: '5px' }}>No</span>
          </label>
        </section>
      </div>
    </VerticalForm>
    
    <section className="field">
      <p>We understand this project is important to you and so, wherever possible we will always try to work within your budget. Estimates are calculated with total transparency to avoid hidden costs on your end. </p>
    </section>

    <PrimaryButton className="button is-rounded" type="submit" disabled={isSubmitting}>
      Submit Order Request
    </PrimaryButton>
  </form>
);

InnerForm.propTypes = {
  values: PropTypes.any,
  errors: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  handleSubmit: PropTypes.any,
  touched: PropTypes.any,
  isSubmitting: PropTypes.any
};

export class OrderComponent extends Component {
  static propTypes = {
    children: PropTypes.any,
    match: PropTypes.any,
    location: PropTypes.any,
    history: PropTypes.any,
    user: PropTypes.object,
    orders: PropTypes.object
  };

  componentDidMount() {    
    if (!this.props.user.authenticated) {
      this.props.history.push('/');
    }

    this.props.dispatch(requestOrdersFromLocalStorage());
  }

  render() {
    let orders = this.props.orders.items.map((song, i) => (<section key={`song_order_${i}`} className="column is-full"><SongOrder song={song} /></section>));

    const MyForm = withFormik({
      mapPropsToValues: _props => ({ order_country: '', order_license: '', order_media: '', order_customized: '0' }),
      validationSchema: Yup.object({
        order_country: Yup.string().required('Order country is required'),
        order_license: Yup.string().required('Order license is required'),
        order_media: Yup.string().required('Order media is required'),
        order_customized: Yup.string().required('Order customized is required'),
      }),
      handleSubmit: (
        values,
        {
          _props,
          _setSubmitting,
          _setErrors /* setValues, setStatus, and other goodies */,
        }
      ) => {
        let ordersArray = this.props.orders.items.map( (ord, i) => ({ product_id: ord.id }));
        let orderData = {
          customer_id: this.props.user.data.user_id,
          line_items: ordersArray,
          status: "processing",
          meta_data: [
            {
              key: 'order_country',
              value: values.order_country
            },
            {
              key: 'order_license',
              value: values.order_license
            },
            {
              key: 'order_media',
              value: values.order_media
            },
            {
              key: 'order_customized',
              value: values.order_customized
            }
          ]
        }

        if (orderData.line_items.length) {
          this.props.dispatch(requestOrder(orderData, this.props.user.data.token, this.props.history));
        } else {
          this.props.dispatch(addNotification(`Please add songs to the order request..`, 'warning'));
        }
      },
    })(InnerForm);

    const HeroBody = () => (
      <Fragment>
        <section className="container">
          <section className="columns is-centered">
            <section className="column is-8 has-text-white">
              <OrderSummaryH1>Order Summary</OrderSummaryH1>
              <OrderSummaryH2>Songs</OrderSummaryH2>
              <hr style={{ marginTop: 0, background: '#2b2b2b' }} />
              <section className="columns is-multiline">
                {orders}
              </section>
              <OrderSummaryH3>License Terms</OrderSummaryH3>
              <section className="field">
                <p>To receive an estimate for all music licenses please fill out the below information and a representative will be in contact shortly.</p>
              </section>
              <MyForm/>
            </section>
          </section>
        </section>
      </Fragment>
    );

    return (
      <Fragment>
        <BulmaHero heroSize="is-fullheight" body={<HeroBody />} activateBodyPadding={true} image={BackgroundImage}></BulmaHero>
      </Fragment>
    );
  }
}

function mapStateToProps({ user, orders }) {
  
  return {
    user,
    orders
  };
}

export const Orders = connect(mapStateToProps)(OrderComponent);


// WEBPACK FOOTER //
// ./src/routes/Orders/Orders.js